// Canonical plan keys, in the same order on the usage and billing views.
// Usage validation treats these keys as a closed contract. Deploy new quota
// definitions here before the API starts returning the corresponding keys.
export const MONTHLY_QUOTAS = {
  merchantApi: { label: "Merchant API", usageLabel: "Merchant API", color: "bg-indigo-500" },
  youzuLens: { label: "Youzu Lens", usageLabel: "Youzu Lens API", color: "bg-pink-500" },
  roomVisualizer: { label: "Room Visualizer", usageLabel: "Room Visualizer API", color: "bg-purple-500" },
  propertyVisualizer: { label: "Property Visualizer", usageLabel: "Property Visualizer API", color: "bg-blue-500" },
  youzuSwap: { label: "Youzu Swap", usageLabel: "Youzu Swap API", color: "bg-green-500" },
  magicBackground: { label: "Magic Background", usageLabel: "Magic Background API", color: "bg-teal-500" },
  twoDTo3d: { label: "2D to 3D", usageLabel: "2D to 3D API", color: "bg-amber-500" },
} as const;

// Quotas the API may still report for retired products. They are dropped from
// usage responses instead of failing the closed-contract validation.
export const RETIRED_MONTHLY_QUOTA_KEYS: readonly string[] = ["youzuFill"];

export const CAPACITY_QUOTAS = {
  catalogues: { label: "Catalogues" },
  catalogueProducts: { label: "Products per catalogue" },
} as const;

export type MonthlyQuotaKey = keyof typeof MONTHLY_QUOTAS;
export type CapacityQuotaKey = keyof typeof CAPACITY_QUOTAS;
export type PlanQuotaKey = MonthlyQuotaKey | CapacityQuotaKey;

export const MONTHLY_QUOTA_KEYS = Object.keys(MONTHLY_QUOTAS) as MonthlyQuotaKey[];
export const CAPACITY_QUOTA_KEYS = Object.keys(CAPACITY_QUOTAS) as CapacityQuotaKey[];
